<template>
    <div class="pro-content flex-1">
        <div class="title" v-show="listData.length > 0">
            <el-row>
                <el-col :span="9" class="first">名称</el-col>
                <el-col :span="3" class="tl">服务人员</el-col>
                <el-col :span="3">单价</el-col>
                <el-col :span="3">数量</el-col>
                <el-col :span="3">小计</el-col>
                <el-col :span="3">
                    <div class="opt-h">操作</div>
                </el-col>
            </el-row>
        </div>
        <div class="content" ref="pro_content">
            <el-row class="line" v-for="(item, i) in listData">
                <el-col :span="9" class="first">
                    <div class="pro-name">
                        {{item.pro_name === 'null' ? "&nbsp;" : item.pro_name}}
                    </div>
                </el-col>
                <el-col :span="3" class="tl">
                    <select-staff :item="item" @selected="(...args) => handleSelect(...args, item)" />
                </el-col>
                <el-col :span="3">
                    <cash-text-input v-model="item.price" @change="resetTotalPrice(item)" />
                </el-col>
                <el-col :span="3">
                    <cash-text-input v-model="item.num" @change="resetTotalPrice(item)" />
                </el-col>
                <el-col :span="3">
                    <cash-text-input v-model="item.total_price" @change="updateProductList" />
                </el-col>
                <el-col :span="3">
                    <div class="opt-c">
                        <el-button type="danger" size="mini" @click="deletePro(i)" v-if="item.is_delete">删除</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import TextInput from "@/model/TextInput";
    import CashTextInput from "@/model/Cash/CashTextInput";
    import SelectStaff from "@/model/SelectStaff";
    export default {
        name: "CashContent",
        components: {SelectStaff, CashTextInput, TextInput},
        props: {
            content: {
                type: Array,
                default: []
            }
        },
        data: () => {
            return {
                listData: []
            };
        },
        mounted: function () {
            this.listData = this.content;
        },
        methods: {
            //清除单个项目
            deletePro: function (i) {
                this.$emit("deleteProduct", i);
            },
            //更新项目列表数据
            updateProductList: function () {
                this.$emit("updateProductList", this.listData);
            },
            //重新计算价格
            resetTotalPrice: function (item) {
                if(!obj.isEmpty(item.discount_data)){
                    if(item.discount_data.mode == 1)
                        item.total_price = item.price * item.num * item.discount_data.data / 10;
                    else
                        item.total_price = item.discount_data.data * item.num;
                }else
                    item.total_price = item.price * item.num;
                item.total_price = item.total_price.toFixed(2);
                this.updateProductList();
            },
            //选择服务人员
            handleSelect: function (staffArr, item) {
                let staff = [];
                if(!obj.isEmpty(staffArr)) {
                    staffArr.forEach( val => {
                       staff.push(val);
                        // {
                        //     id: val.id,
                        //         is_assign: val.is_assign
                        // }
                    });
                }
                item.staff = staff;
            }
        },
        watch: {
            content: function (data) {
                this.listData = data;
            },
            listData: function () {
                obj.unScrollbar(".pro-content");
                this.$nextTick(() => {
                    obj.scrollbar(".pro-content");
                });
            }
        }
    }
</script>

<style scoped>
    .pro-content .title {
        box-sizing: border-box;
        width: 100%;
        height: 50px;
        line-height: 50px;
        overflow: hidden;
        text-align: center;
        border-bottom: 1px solid #ebedf0;
        font-size: 14px;
        font-weight: bold;
        color: #909399;
    }
    .pro-content .content {
        overflow: hidden;
        text-align: center;
        padding-bottom: 16px;
    }
    .pro-content .content .line {
        line-height: 45px;
        /*padding: 5px 0;*/
        border-bottom: 1px solid #ebedf0;
        overflow:hidden;
    }
    .pro-content .content .line>.el-col>*{
        display: inline-block;
        vertical-align: middle;
    }
    .pro-content .content .line:hover{
        background-color: #F5F7FA;
    }
    .select_staff{
        border: none;
    }
    .first{
        padding-left: 30px;
        text-align: left;
    }
    .pro-name{
        line-height: 22px;
        padding: 11px 80px 11px 0;
    }
    .opt-h,.opt-c{
        display: block !important;
        text-align: right;
        margin-right: 10px;
    }
    .opt-h{
        padding-right: 15px;
    }
</style>
